(function () {
  'use strict';

  if (window.ZWIMLazyMedia) { return; }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var loadObserver = null;
  var playObserver = null;

  function loadBackground(element) {
    var source = element.getAttribute('data-zp-lazy-bg');
    if (!source) { return; }
    element.style.backgroundImage = 'url("' + source.replace(/"/g, '%22') + '")';
    element.removeAttribute('data-zp-lazy-bg');
  }

  function loadVideo(video) {
    if (!video) { return; }
    if (video.getAttribute('data-zp-loaded') === '1') { return; }
    var source = video.getAttribute('data-src');
    if (!source) { return; }
    video.setAttribute('data-zp-loaded', '1');
    video.src = source;
    video.preload = saveData ? 'metadata' : 'auto';
    video.load();
  }

  function playVideo(video) {
    if (!video || reduceMotion.matches || saveData || document.visibilityState !== 'visible') { return; }
    loadVideo(video);
    video.muted = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function observe(scope) {
    var root = scope || document;
    var backgrounds = root.querySelectorAll('[data-zp-lazy-bg]');
    var videos = root.querySelectorAll('[data-zp-lazy-video]');

    Array.prototype.forEach.call(backgrounds, function (element) {
      if (loadObserver) { loadObserver.observe(element); } else { loadBackground(element); }
    });

    Array.prototype.forEach.call(videos, function (video) {
      if (video.getAttribute('data-zp-observed') === '1') { return; }
      video.setAttribute('data-zp-observed', '1');
      video.muted = true;
      if (loadObserver) { loadObserver.observe(video); } else { loadVideo(video); }
      if (video.hasAttribute('data-zp-autoplay') && playObserver) { playObserver.observe(video); }
    });
  }

  if ('IntersectionObserver' in window) {
    loadObserver = new IntersectionObserver(function (entries, observer) {
      Array.prototype.forEach.call(entries, function (entry) {
        if (!entry.isIntersecting) { return; }
        if (entry.target.hasAttribute('data-zp-lazy-bg')) {
          loadBackground(entry.target);
        } else {
          loadVideo(entry.target);
        }
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '700px 0px', threshold: 0.01 });

    playObserver = new IntersectionObserver(function (entries) {
      Array.prototype.forEach.call(entries, function (entry) {
        var video = entry.target;
        video.setAttribute('data-zp-inview', entry.isIntersecting ? '1' : '0');
        if (entry.isIntersecting) {
          playVideo(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: 0.2 });
  }

  function syncVisibleVideos() {
    var videos = document.querySelectorAll('[data-zp-autoplay][data-zp-inview="1"]');
    Array.prototype.forEach.call(videos, function (video) {
      if (document.visibilityState === 'visible') { playVideo(video); }
      else if (!video.paused) { video.pause(); }
    });
  }

  window.ZWIMLazyMedia = {
    loadVideo: loadVideo,
    observe: observe
  };

  observe(document);
  document.addEventListener('visibilitychange', syncVisibleVideos);
  document.addEventListener('shopify:section:load', function (event) { observe(event.target); });
})();
